<template>
  <div
    id="app"
    v-if="hasInitLang">
    <headerCc
      v-if="noBlankPage"
      @ShowPop="IsPopShow = true"></headerCc>
    <!-- 状态搜索弹出框 -->
    <secondary-record
      v-if="IsPopShow && noBlankPage"
      @HiddenPop="IsPopShow = false"></secondary-record>
    <el-main class="scrollbar">
      <router-view :key="dataMark"></router-view>
    </el-main>
  </div>
</template>

<script>
import HeaderCc from '@/components/common/HeaderCc'
import { mapActions, mapState } from 'vuex'
import Bus from '@/assets/js/vueBus.js'
import { loadSudoku, loadLanguageJs, loadVersionNews } from '@/assets/js/loadSudoku.js'
import SecondaryRecord from '@/views/PlayoutPlus/common/SecondaryRecord.vue'
import toTips from '@/assets/js/toTipsObj'
import Outil from '@/assets/js/utils.js'

export default {
  name: 'App',
  data () {
    return {
      //   不是空白页
      noBlankPage: true,
      dataMark: '',
      visible: {
        notice: false
      },
      noticeMsg: [],
      role: null,
      // 是否显示状态弹出框
      IsPopShow: false,
      // 当前用户session
      UserSession: ''
    }
  },
  components: {
    HeaderCc,
    SecondaryRecord
  },
  computed: {
    ...mapState('common', {
      hasInitLang: (state) => state.hasInitLang,
      baseUserInfo: (state) => state.baseUserInfo
    })
  },
  beforeCreate () {
    const urlVal = JSON.parse(window.localStorage.channelInitConfig).urlInfo.mySourceUrl
    if (window.location.hostname == urlVal) {
      window.location.href = `${window.location.origin}${window.location.pathname}${window.location.hash}${window.location.search}`
    }
  },
  created () {
    // 当initConfig成功时存储变量，加载九宫格
    loadSudoku(
      JSON.parse(window.localStorage.channelInitConfig).urlInfo || {},
      Outil.getSession()
    )
    // 当全局变量存储好之后开始调用language公共js
    loadLanguageJs()
    // 集成VersionNew
    loadVersionNews(JSON.parse(window.localStorage.channelInitConfig).urlInfo || {}, Outil.getSession())
    Bus.$on('roleInfo', async (role) => {
      if (this.role !== null || !['3', '4'].includes(role)) return
      this.role = role
      await this.showNotice()
      setTimeout(() => {
        if (this.visible.notice) $('body .v-modal').addClass('notice')
      }, 100)
    })
    this.identify()
  },
  mounted () {
    this.setRem()
    document.cookie = 'aa=123;path=/;domain=.tvunetworks.com;secure'
    document.addEventListener('visibilitychange', this.getPageHideShow)
    // 全局捕获未处理的 Promise 被拒绝的情况
    window.onunhandledrejection = event => {
      console.error('Unhandled Promise rejection:', event.reason)
    }
  },
  methods: {
    // 获取页面离开与进入
    getPageHideShow (e) {
      if (e.target.visibilityState == 'visible') {
        const current = Outil.getSession()
        // 对比和之前用户是否一致
        if (this.UserSession && current && this.UserSession != current) {
          this.PageSwitch()
        }
      } else if (e.target.visibilityState == 'hidden') {
        this.UserSession = Outil.getSession()
      }
    },
    // 页面切回时不是一个用户，重新更新用户信息，解决页面切换白屏的问题
    PageSwitch () {
      this.axios.get('/gatewayPlayoutUrl/tvu-playout/user/initLoginUser').then((res) => {
        if (res.data.errorCode == '0x0') {
          const data = { userInfo: res.data.result } || {}
          localStorage.setItem('userId', data.userInfo.id)
          this.$store.commit('common/BASE_USER_INFO', data)
        }
        if (this.$route.path == '/wb') {
          location.reload()
        } else {
          this.UserSession = ''
          this.$router.push({
            path: '/wb'
          })
        }
      }).catch(() => {})
    },
    setRem () {
      // let whdef = 100 / 1920; // 表示1920的设计图,使用100PX的默认值
      // let wW = window.innerWidth; // 当前窗口的宽度
      const rem = 100 // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
      $('html').css('font-size', `${rem}px`)
      $(window).resize(() => {
        // let whdef = 100 / 1920; // 表示1920的设计图,使用100PX的默认值
        // let wW = window.innerWidth; // 当前窗口的宽度
        // const rem = 100 // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
        $('html').css('font-size', `${rem}px`)
      })
    },
    // 是否为第一次登陆进来
    isLogin () {
      if (localStorage.getItem('channelSession') != localStorage.getItem('lastSession')) {
        localStorage.setItem('lastSession', localStorage.getItem('channelSession'))
        return true
      }
      return false
    },
    // 如果是登录后第一次进入页面，显示通知
    async showNotice () {
      if (this.isLogin()) {
        await this.axios.post('/gatewayPlayoutUrl/tvu-playout/extra/getNotice', {}).then((res) => {
          if (res.status == 200) {
            if (res.data.errorCode == '0x0') {
              if (res.data.result.length) {
                // res.data.result = [{featureName: 'TokenSystem'}, {featureName: 'GridEncoder'}, {featureName: 'Grid'}]
                this.noticeMsg = []
                res.data.result.forEach((v) => {
                  if (v.featureName.toLowerCase().includes('tokensystem')) {
                    this.noticeMsg.push('TVU Anywhere Token System')
                  }
                  if (!this.noticeMsg.includes('TVU Grid') && v.featureName.toLowerCase().includes('grid')) {
                    this.noticeMsg.push('TVU Grid')
                  }
                })
                this.visible.notice = true
              }
            } else {
              const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
              this.$message.info(errorInfo)
            }
          }
        }).catch(() => {})
        return
      }
      this.visible.notice = false
      $('body .v-modal').removeClass('notice')
    },
    // Appcues传入邮箱
    identify () {
      this.$nextTick(() => {
        window.Appcues.identify(
          this.baseUserInfo.email
        )
      })
    }
  },
  watch: {
    $route (to, from) {
      this.dataMark = to.path
      this.noBlankPage = (this.dataMark != '/kb' && to.path != '/ob')
      // 跳转时让弹出框消失
      this.IsPopShow = false
    }
  },
  beforeDestroy () {
    Bus.$off('roleInfo')
    document.removeEventListener('visibilitychange', this.getPageHideShow)
  }
}
</script>
<style lang="less">
.GlobalStyle
#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  // background:#444;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
body {
  #news_nav_icon_bg{
    z-index: 10000;
    right: 125px;
    top: 16px;
  }
}
::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 2px; /*高宽分别对应横竖滚动条的尺寸*/
}

::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 5px;
  background-color: rgba(144, 147, 153, 0.3);
  opacity: 0.7;
}

::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  border-radius: 5px;
  background: none;
}
.tvu-source-type .el-select-dropdown__wrap .el-select-dropdown__item .el-icon-check{
  display: none;
}
.GlobalStyle .el-main {
  color: #fff;
}
.el-main {
  background: #242424;
  height: calc(100% - 64px);
  overflow-y: auto;
}
@media (max-width: 1280px) {
  .el-main {
    width: 1280px;
  }
}
@media (max-width: 1024px) {
  .el-main {
    height: calc(100% - 60px);
  }
}
</style>
